import React, { FC, Fragment, useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router";
import * as AppRoutes from "../../../routes/routeConstants/appRoutes";
import AuthService from "../../../services/AuthService/auth.service";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthState } from "../../../store/reducers/authReducer";
import { numberConvention } from "../../utils/numberConvention";
import MobileInputModal from "../MobileInputModal";
import NotificationIcon from "./../../../assets/icons/multi color icons - svg/notificaction.svg";
import "./pageHeader.scss";
import { Col, Divider, Menu, Row, Space, Typography } from "antd";
import WalletStaticIcon from "./../../../assets/icons/multi color icons - svg/static wallet - blue.svg";
import ClockCustom from "../../../assets/icons/clock-custom.svg";
import NotificationService from "../../../services/NotificationService/notification.service";
import moment from "moment";
import { DateFormats } from "../../../enums/dateFormat";
import { TypesOfNavigation } from "../../../enums/notificationNavigationTypes";
import clsx from "clsx";
import FarwardArrow from "./../../../assets/icons/backArrow.svg";
import UIModal from "../UIModal";
import { Input } from "antd";

type investmentDetails = {
  investmentAmount: Number;
  investmentTime: Number;
  investmentMonths: Number;
  investedYear: Number;
};
interface PageHeaderProps extends AuthState {
  title: string;
  showSubtitles?: boolean;
  titleBadge?: string;
  showWallet?: boolean;
  showUpgrade?: boolean;
  investment_details: investmentDetails;
  isExtraBold?: boolean;
  showPopUpTitle?: boolean;
  ruleCallback?: () => void;
  upgradeOnclickHandler?: () => void;
  isHome?: boolean;
}

const { Text } = Typography;

const PageHeader: FC<PageHeaderProps> = (props) => {
  const history = useHistory();
  const {
    title,
    showWallet = false,
    user,
    showSubtitles,
    isExtraBold,
    showPopUpTitle,
    ruleCallback,
    upgradeOnclickHandler,
    isHome,
  } = props;
  const {
    getWalletDetails,
    wallet,
    applyReferralCode,
    loading: authLoading,
  } = AuthService();
  const { fetchNotifications, notifications, markOneAsRead, markAllAsRead } =
    NotificationService();
  const [mobileModal, setMobileModal] = useState<boolean>(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);

  const subtitles = [
    user?.role === "chama" ? "Group" : user?.role,
    user?.uid?.split("-").pop(),
    user?.memberSince && "Member since " + user?.memberSince,
  ];

  useEffect(() => {
    if (user?.kycAccepted) getWalletDetails();
    void fetchNotifications();
  }, []);

  const subtitleTemplate = subtitles?.map((subtitle, index) => {
    return (
      subtitle && (
        <Fragment key={subtitle}>
          <span>{subtitle}</span>
          {index + 1 !== subtitles.length && <hr />}
        </Fragment>
      )
    );
  });

  const changeNotificationsState = () => {
    setShowNotifications((prevShowNotifications) => !prevShowNotifications);
  };

  const markAllNotificationsAsRead = async () => {
    const res = await markAllAsRead();
    if (res === 200) {
      await fetchNotifications();
      setShowNotifications(false);
    }
  };

  const markOneNotificationsAsRead = async (id: string, type: string) => {
    const res = await markOneAsRead({ id });
    if (res === 200) {
      await fetchNotifications();
      setShowNotifications(false);
      
      if (isHome) {
        return;
      }
      
      if (type === TypesOfNavigation.Dividend) {
        history.push(AppRoutes.WALLET);
      } else if (type === TypesOfNavigation.Subscription) {
        history.push(AppRoutes.PROFILE);
      } else if (type === TypesOfNavigation.Orders) {
        history.push(AppRoutes.HOLDINGS);
      }
    }
  };

  const handleReferralModalOpen = () => {
    setShowReferralModal(true);
  };

  const handleReferralModalClose = () => {
    setShowReferralModal(false);
    setReferralCodeValue("");
  };

  const handleReferralSubmit = async (values: { referralCode: string }) => {
    const result = await applyReferralCode(values.referralCode);
    if (result?.success) {
      handleReferralModalClose();
    }
  };

  const [referralCodeValue, setReferralCodeValue] = useState<string>("");

  return (
    <div className="page-header__container">
      {title && (
        <div
          className={
            "page-header__details " +
            (showPopUpTitle
              ? "investmentTitle"
              : showSubtitles && "subtitle-placeholder")
          }
        >
          <h2
            className={clsx(
              "page-header__details--title",
              isExtraBold && "extra-bold",
            )}
          >
            {title}
            {showSubtitles && user?.tier?.name && (
              <p
                className={
                  "page-header__details--title-badge " + user?.tier?.name
                }
              >
                <i className="icon-subscription" />
                <span>{user?.tier?.name}</span>
              </p>
            )}
            {isHome && (
              <span className="upgradeItem" onClick={upgradeOnclickHandler}>
                Upgrade{"  "}
                <img
                  src={FarwardArrow}
                  width="14"
                  alt="warning-icon"
                  className="upgradeIcon"
                />
              </span>
            )}
          </h2>

          {showSubtitles && (
            <div className="page-header__details--subtitle">
              {subtitleTemplate}
            </div>
          )}
          {showPopUpTitle && (
            <div className="investmentRule mr-2" onClick={ruleCallback}>
              Investment Rule{" "}
            </div>
          )}
        </div>
      )}
      {showWallet && wallet && (
        <div className="page-header__wallet--container">
          <p className="page-header__wallet">
            <img
              src={WalletStaticIcon}
              alt="wallet"
              className="page-header__wallet--icon"
            />
            <h3 className="page-header__wallet--heading">
              Total Wallet Balance
            </h3>
            <h3 className="page-header__wallet--amount">{`${numberConvention(
              (wallet.dynamicBalance ?? 0) + (wallet.staticBalance ?? 0),
            )} KES`}</h3>
          </p>
          <Divider type="vertical" className="page-header__wallet-divider" />
          <div>
            <Row className="" justify="end" align="middle" gutter={[20, 0]}>
              <Col>
                <div
                  className={`wallet__notification ${
                    notifications?.length === 0 ? "" : "badge"
                  }`}
                  onClick={changeNotificationsState}
                >
                  <img src={NotificationIcon} alt="notification" />
                </div>
              </Col>
              <Divider
                type="vertical"
                className="page-header__wallet-divider"
              />
              {user?.isReferralApplied === true && (
                <Col>
                  <button
                    className="referral-code-btn"
                    onClick={handleReferralModalOpen}
                  >
                    Have a Referral code?
                  </button>
                </Col>
              )}
            </Row>
            {showNotifications && (
              <Row
                className="wallet__notifications-menu"
                justify="space-between"
              >
                <Col span={24}>
                  <Row
                    className="wallet__notifications-header notifications-header"
                    justify="space-between"
                  >
                    <Col>
                      <Row gutter={[8, 32]} align="middle">
                        <Col className="notifications-header__icon">
                          <img src={NotificationIcon} alt="notification" />
                        </Col>
                        <Col className="notifications-header__text">
                          <p>Notification</p>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      className="notifications-header__mark-all"
                      onClick={() => {
                        void markAllNotificationsAsRead();
                      }}
                    >
                      <p>Mark all as read</p>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Menu
                    mode="vertical"
                    className="wallet__notifications-menu__menu"
                  >
                    {notifications?.map((i, j) => {
                      return (
                        <Menu.Item
                          key={j}
                          className="wallet__notifications-menu__item"
                          onClick={() => {
                            void markOneNotificationsAsRead(
                              i.id ?? "",
                              i.data?.type ?? "",
                            );
                          }}
                        >
                          <Row align="top">
                            <Col span={24}>
                              <Row className="wallet__notifications-menu__item-row">
                                <Col span={24}>
                                  <Text className={"text--blue"}>
                                    {i.data?.title}
                                  </Text>
                                </Col>
                                <Col span={24}>
                                  <Space direction="horizontal">
                                    <Col>
                                      <img src={ClockCustom} alt="clock-icon" />
                                    </Col>
                                    <Text
                                      type="secondary"
                                      className="notification__item-row-date"
                                    >
                                      {moment(i.createdAt).format(
                                        DateFormats.DEFAULT,
                                      )}
                                    </Text>
                                  </Space>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Menu.Item>
                      );
                    })}
                  </Menu>
                </Col>
              </Row>
            )}
          </div>
        </div>
      )}
      <MobileInputModal
        visible={mobileModal}
        onOk={() => {
          setMobileModal(false);
        }}
        onCancel={() => {
          setMobileModal(false);
        }}
      />

      <UIModal
        title="Have a Referral Code?"
        visible={showReferralModal}
        onClose={handleReferralModalClose}
        onOk={() => {
          if (referralCodeValue.trim()) {
            handleReferralSubmit({ referralCode: referralCodeValue });
          }
        }}
        okText="Proceed"
        className="referral-modal"
        loading={authLoading}
      >
        <div className="referral-form">
          <div style={{ marginTop: 5, marginBottom: 16 }}>
            <Input
              placeholder="Enter referral code"
              value={referralCodeValue}
              onChange={(e) => setReferralCodeValue(e.target.value)}
              className="referral-input-field"
              size="large"
            />
          </div>
        </div>
      </UIModal>
    </div>
  );
};

export default AuthContainer(PageHeader);
